import React, { useState } from "react";
import "./Milan.css";

// ── All 28 Nakshatras (including Abhijit) ──────────────────────────────────
const NAKSHATRAS = [
  "अश्विनी",
  "भरणी",
  "कृत्तिका",
  "रोहिणी",
  "मृगशिरा",
  "आर्द्रा",
  "पुनर्वसु",
  "पुष्य",
  "आश्लेषा",
  "मघा",
  "पू.फा.",
  "उ.फा.",
  "हस्त",
  "चित्रा",
  "स्वाती",
  "विशाखा",
  "अनुराधा",
  "ज्येष्ठा",
  "मूल",
  "पू.षा.",
  "उ.षा.",
  "अभिजित्",
  "श्रवण",
  "धनिष्ठा",
  "शतभिषा",
  "पू.भा.",
  "उ.भा.",
  "रेवती",
];

// ── Main Ashtakoota table data ─────────────────────────
const TABLE_DATA = {
  "चरणगत नामाक्षर": [
    "चु चे चो ला",
    "ली लू ले लो",
    "अ ई उ ए",
    "ओ वा वी वू",
    "वे वो का की",
    "कु घ ङ छ",
    "के को हा ही",
    "हू हे हो डा",
    "डी डू डे डो",
    "मा मी मू मे",
    "मो टा टी टू",
    "टे टो पा पी",
    "पू ष ण ठ",
    "पे पो रा री",
    "रू रे रो ता",
    "ती तु ला नी",
    "नो या यी यू",
    "यो भा भी",
    "भू घा ढा",
    "भे भो जा जी",
    "जू जे जो ख",
    "जु जे जो ख", // अभिजित्
    "खी खू खे खो",
    "गा गी गू गे",
    "गो सा सी सू",
    "से सो दा दी",
    "दू थ झ ञ",
    "दे दो च ची",
  ],
  राशि: [
    "मेष",
    "मेष",
    "मे.१ वृ.३",
    "वृष",
    "वृ.२ मि.२",
    "मिथुन",
    "मि.३ क.१",
    "कर्कट",
    "कर्कट",
    "सिंह",
    "सिंह",
    "सि.१ कं.३",
    "कन्या",
    "कं.२ तु.२",
    "तुला",
    "तु.३ वृ.१",
    "वृश्चिक",
    "वृश्चिक",
    "धनु",
    "धनु",
    "ध.१ म.३",
    "उ.षा.४ श्र.१५", // अभिजित्
    "मकर",
    "म.२ कुं.२",
    "कुम्भ",
    "कुं.३ मी.१",
    "मीन",
    "मीन",
  ],
  "रा.स्वामी": [
    "भौम",
    "भौम",
    "भौ.१ शुक्र.३",
    "शुक्र",
    "शु.२ बुध.२",
    "बुध",
    "बु.३ चन्द्र.१",
    "चन्द्र",
    "चन्द्र",
    "सूर्य",
    "सूर्य",
    "सू.१ बुध.३",
    "बुध",
    "बु.२ शुक्र.२",
    "शुक्र",
    "शु.३ भौम.१",
    "भौम",
    "भौम",
    "गुरु",
    "गुरु",
    "गु.१ शनि.३",
    "शनि", // अभिजित्
    "शनि",
    "श.२ शनि.२",
    "शनि",
    "श.३ गुरु.१",
    "गुरु",
    "गुरु",
  ],
  वर्ण: [
    "क्षत्रि",
    "क्षत्रि",
    "क्ष.१ वै.३",
    "वैश्य",
    "वै.२ शू.२",
    "शूद्र",
    "शू.३ विप्र.१",
    "विप्र",
    "विप्र",
    "क्षत्रि",
    "क्षत्रि",
    "क्ष.१ वै.३",
    "वैश्य",
    "वै.२ शू.२",
    "शूद्र",
    "शू.३ विप्र.१",
    "विप्र",
    "विप्र",
    "क्षत्रि",
    "क्षत्रि",
    "क्ष.१ वै.३",
    "वैश्य", // अभिजित्
    "वैश्य",
    "वै.२ शू.२",
    "शूद्र",
    "शू.३ विप्र.१",
    "विप्र",
    "विप्र",
  ],
  वश्य: [
    "चतुष्पद",
    "चतुष्पद",
    "चतुष्पद",
    "चतुष्पद",
    "च.२ द्वि.२",
    "द्विपद",
    "द्वि.३ जल.१",
    "जलचर",
    "जलचर",
    "चतुष्पद",
    "चतुष्पद",
    "च.१ द्वि.३",
    "द्विपद",
    "द्वि.२ द्वि.२",
    "द्विपद",
    "द्वि.३ कीट.१",
    "कीट",
    "कीट",
    "मनुष्य",
    "भू.म.३ च",
    "म.१ च.३",
    "चतुष्पद", // अभिजित्
    "च.१ द्वि.२",
    "च.२ द्वि.२",
    "द्विपद",
    "द्वि.३ जल.१",
    "जलचर",
    "जलचर",
  ],
  योनि: [
    "अश्व",
    "गज",
    "अज",
    "सर्प",
    "सर्प",
    "श्वान",
    "मार्जार",
    "अज",
    "मार्जार",
    "मूषक",
    "मूषक",
    "गौ",
    "महिष",
    "व्याघ्र",
    "महिष",
    "व्याघ्र",
    "मृग",
    "मृग",
    "श्वान",
    "वानर",
    "नकुल/अज",
    "नकूल/अज", // अभिजित्
    "वानर",
    "सिंह",
    "अश्व",
    "सिंह",
    "गौ",
    "गज",
  ],
  वैरयोनि: [
    "महिष",
    "सिंह",
    "वानर",
    "नकूल",
    "नकूल",
    "मृग",
    "मूषक",
    "वानर",
    "मूषक",
    "मार्जार",
    "मार्जार",
    "व्याघ्र",
    "अश्व",
    "गौ",
    "अश्व",
    "गौ",
    "श्वान",
    "श्वान",
    "मृग",
    "अज",
    "सर्प",
    "अज गज", // अभिजित्
    "अज",
    "गज",
    "महिष",
    "गज",
    "व्याघ्र",
    "सिंह",
  ],
  गण: [
    "देव",
    "नर",
    "राक्षस",
    "नर",
    "देव",
    "नर",
    "देव",
    "देव",
    "राक्षस",
    "राक्षस",
    "नर",
    "नर",
    "देव",
    "राक्षस",
    "देव",
    "राक्षस",
    "देव",
    "राक्षस",
    "राक्षस",
    "नर",
    "नर",
    "नर देव", // अभिजित्
    "देव",
    "राक्षस",
    "राक्षस",
    "नर",
    "नर",
    "देव",
  ],
  नाडी: [
    "आद्य",
    "मध्य",
    "अन्त्य",
    "अन्त्य",
    "मध्य",
    "आद्य",
    "आद्य",
    "मध्य",
    "अन्त्य",
    "अन्त्य",
    "मध्य",
    "आद्य",
    "आद्य",
    "मध्य",
    "अन्त्य",
    "अन्त्य",
    "मध्य",
    "आद्य",
    "आद्य",
    "मध्य",
    "अन्त्य",
    "अन्त्य", // अभिजित्
    "मध्य",
    "आद्य",
    "आद्य",
    "मध्य",
    "अन्त्य",
    "अन्त्य",
  ],
  आसन: [
    "अश्व",
    "प्रेत",
    "अग्निकुण्ड",
    "गौ",
    "मृग",
    "सर्प",
    "कमल",
    "कलश",
    "काक",
    "महिष",
    "शिला",
    "शिला",
    "गज",
    "मयूर",
    "डोल",
    "अज",
    "हंस",
    "कच्छप",
    "मूल",
    "शयन",
    "शयन",
    "शयन नर", // अभिजित्
    "नर",
    "आढक",
    "वृष",
    "भद्रपीठ",
    "भवपीठ",
    "भक",
  ],
};

// ── नाडी गुण table ─────────────────────────────────────
const NAADI_LABELS = ["आदि नाडी", "मध्य नाडी", "अन्त्य नाडी"];
const NAADI_SCORES = [
  [0, 8, 8],
  [8, 0, 8],
  [8, 8, 0],
];

// ── गण गुण table ───────────────────────────────────────
const GAN_LABELS = ["देव", "नर", "राक्षस"];
const GAN_SCORES = [
  [6, 5, 1],
  [5, 6, 1],
  [0, 0, 6],
];

// ── Garuda table ───────────────────────────────────────
const GARUDA_HEADERS = [
  "अ अ उ ए ओ",
  "क ख ग घ ड",
  "च छ ज झ ञ",
  "ट ठ ड ढ ण",
  "त थ द ध न",
  "प फ ब भ म",
  "य र ल व",
  "श ष स ह",
];
const GARUDA_ROWS = {
  वर्ग: ["गरुड", "मार्जार", "सिंह", "श्वान", "सर्प", "मूषक", "मृग", "मेष"],
  शत्रुवर्ग: ["सर्प", "मूषक", "मृग", "मेष", "गरुड", "मार्जार", "सिंह", "श्वान"],
};

const KOOT_INFO = [
  { name: "वर्ण", max: 1, desc: "आध्यात्मिक अनुकूलता" },
  { name: "वश्य", max: 2, desc: "आकर्षण र नियन्त्रण" },
  { name: "तारा", max: 3, desc: "नक्षत्र अनुकूलता" },
  { name: "योनि", max: 4, desc: "शारीरिक अनुकूलता" },
  { name: "ग्रहमैत्री", max: 5, desc: "मानसिक अनुकूलता" },
  { name: "गण", max: 6, desc: "स्वभाव अनुकूलता" },
  { name: "भकूट", max: 7, desc: "प्रेम र स्वास्थ्य" },
  { name: "नाडी", max: 8, desc: "स्वास्थ्य र सन्तान" },
];

const ROW_COLORS = {
  नक्षत्र: "row-accent",
  राशि: "row-highlight",
  गण: "row-highlight",
  नाडी: "row-accent",
};

export default function Milan() {
  const [activeTab, setActiveTab] = useState("table");
  const [hoveredCol, setHoveredCol] = useState(null);

  const rows = Object.entries(TABLE_DATA);

  return (
    <div className="milan-page">
      {/* ── Mandala ── */}
      <div className="hero-mandala" aria-hidden="true">
        <div className="mandala-ring ring-1" />
        <div className="mandala-ring ring-2" />
        <div className="mandala-ring ring-3" />
        <span className="mandala-om">ॐ</span>
      </div>

      <div className="milan-container">
        {/* ── Header ── */}
        <p className="hero-eyebrow">💍 वैदिक ज्योतिष • नेपाल</p>
        <h1 className="milan-title">कुण्डली मिलान</h1>
        <p className="milan-subtitle">अथावकहडाचक्रसहितं वरवधूमेलापकचक्रम्</p>

        {/* ── Koot summary cards ── */}
        <div className="koot-grid">
          {KOOT_INFO.map((k) => (
            <div key={k.name} className="koot-card">
              <span className="koot-name">{k.name}</span>
              <span className="koot-max">{k.max} गुण</span>
              <span className="koot-desc">{k.desc}</span>
            </div>
          ))}
        </div>
        <p className="koot-total">जम्मा: ३६ गुण मध्ये १८+ उत्तम मानिन्छ</p>

        {/* ── Tabs ── */}
        <div className="milan-tabs">
          <button
            className={activeTab === "table" ? "mtab active" : "mtab"}
            onClick={() => setActiveTab("table")}
          >
            मेलापक चक्र
          </button>
          <button
            className={activeTab === "garuda" ? "mtab active" : "mtab"}
            onClick={() => setActiveTab("garuda")}
          >
            गरुडादिवर्ग
          </button>
          <button
            className={activeTab === "notes" ? "mtab active" : "mtab"}
            onClick={() => setActiveTab("notes")}
          >
            भीमदोष
          </button>
        </div>

        {/* ══ MAIN TABLE ══ */}
        {activeTab === "table" && (
          <>
            {/* Scrollable chakra table */}
            <div className="milan-scroll">
              <table className="milan-table">
                <thead>
                  <tr>
                    <th className="th-label">नक्षत्र</th>
                    {NAKSHATRAS.map((n, i) => (
                      <th
                        key={i}
                        className={`th-naksha ${hoveredCol === i ? "col-hover" : ""}`}
                        onMouseEnter={() => setHoveredCol(i)}
                        onMouseLeave={() => setHoveredCol(null)}
                      >
                        {n}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {rows.map(([rowName, values], ri) => (
                    <tr key={ri} className={ROW_COLORS[rowName] ?? ""}>
                      <td className="td-label">{rowName}</td>
                      {values.map((val, ci) => (
                        <td
                          key={ci}
                          className={`td-val ${hoveredCol === ci ? "col-hover" : ""}`}
                          onMouseEnter={() => setHoveredCol(ci)}
                          onMouseLeave={() => setHoveredCol(null)}
                        >
                          {val}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* ── नाडी गुण + गण गुण side by side below main table ── */}
            <div
              style={{
                display: "flex",
                gap: "1.5rem",
                flexWrap: "wrap",
                marginTop: "2rem",
              }}
            >
              {/* नाडी गुण */}
              <div style={{ flex: "1 1 280px" }}>
                <h3
                  style={{
                    color: "#f0c060",
                    marginBottom: "0.6rem",
                    fontSize: "1rem",
                    letterSpacing: "0.03em",
                  }}
                >
                  नाडी गुण तालिका{" "}
                  <span style={{ color: "#aaa", fontSize: "0.82rem" }}>
                    (अधिकतम ८)
                  </span>
                </h3>
                <table className="milan-table garuda-table">
                  <thead>
                    <tr>
                      <th className="th-label" style={{ color: "#e8c97a" }}>
                        कन्या \ वर
                      </th>
                      {NAADI_LABELS.map((l) => (
                        <th
                          key={l}
                          className="th-naksha"
                          style={{ color: "#7ecfff" }}
                        >
                          {l}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {NAADI_LABELS.map((rowLabel, ri) => (
                      <tr
                        key={ri}
                        className={
                          ri % 2 === 0 ? "row-accent" : "row-highlight"
                        }
                      >
                        <td className="td-label" style={{ color: "#7ecfff" }}>
                          {rowLabel}
                        </td>
                        {NAADI_SCORES[ri].map((score, ci) => (
                          <td
                            key={ci}
                            className="td-val"
                            style={{
                              fontWeight: "bold",
                              fontSize: "1.05rem",
                              color: score === 0 ? "#ff5c5c" : "#6dff9e",
                            }}
                          >
                            {score}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* गण गुण */}
              <div style={{ flex: "1 1 240px" }}>
                <h3
                  style={{
                    color: "#f0c060",
                    marginBottom: "0.6rem",
                    fontSize: "1rem",
                    letterSpacing: "0.03em",
                  }}
                >
                  गण गुण तालिका{" "}
                  <span style={{ color: "#aaa", fontSize: "0.82rem" }}>
                    (अधिकतम ६)
                  </span>
                </h3>
                <table className="milan-table garuda-table">
                  <thead>
                    <tr>
                      <th className="th-label" style={{ color: "#e8c97a" }}>
                        कन्या \ वर
                      </th>
                      {GAN_LABELS.map((l) => (
                        <th
                          key={l}
                          className="th-naksha"
                          style={{ color: "#7ecfff" }}
                        >
                          {l}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {GAN_LABELS.map((rowLabel, ri) => (
                      <tr
                        key={ri}
                        className={
                          ri % 2 === 0 ? "row-accent" : "row-highlight"
                        }
                      >
                        <td className="td-label" style={{ color: "#7ecfff" }}>
                          {rowLabel}
                        </td>
                        {GAN_SCORES[ri].map((score, ci) => (
                          <td
                            key={ci}
                            className="td-val"
                            style={{
                              fontWeight: "bold",
                              fontSize: "1.05rem",
                              color:
                                score === 0
                                  ? "#ff5c5c"
                                  : score === 6
                                    ? "#6dff9e"
                                    : score === 5
                                      ? "#ffe066"
                                      : "#ffaa55",
                            }}
                          >
                            {score}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* ── Koota Points + Guna Milan Importance tables ── */}
            <div
              style={{
                display: "flex",
                gap: "1.5rem",
                flexWrap: "wrap",
                marginTop: "2rem",
              }}
            >
              {/* अष्टकूट अधिकतम गुण */}
              <div style={{ flex: "1 1 260px" }}>
                <h3
                  style={{
                    color: "#f0c060",
                    marginBottom: "0.6rem",
                    fontSize: "1rem",
                    letterSpacing: "0.03em",
                  }}
                >
                  अष्टकूट गुण तालिका{" "}
                  <span style={{ color: "#aaa", fontSize: "0.82rem" }}>
                    (जम्मा ३६)
                  </span>
                </h3>
                <table className="milan-table garuda-table">
                  <thead>
                    <tr>
                      <th className="th-label" style={{ color: "#e8c97a" }}>
                        कूट
                      </th>
                      <th className="th-naksha" style={{ color: "#7ecfff" }}>
                        अधिकतम गुण
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { koot: "वर्ण", max: 1 },
                      { koot: "वश्य/वाश्य", max: 2 },
                      { koot: "तारा/दिना", max: 3 },
                      { koot: "योनि", max: 4 },
                      { koot: "ग्रहमैत्री/राशिपति", max: 5 },
                      { koot: "गण", max: 6 },
                      { koot: "राशि/भकूट", max: 7 },
                      { koot: "नाडी", max: 8 },
                      { koot: "जम्मा", max: 36, total: true },
                    ].map(({ koot, max, total }, i) => (
                      <tr
                        key={i}
                        className={
                          total
                            ? "row-highlight"
                            : i % 2 === 0
                              ? "row-accent"
                              : ""
                        }
                      >
                        <td
                          className="td-label"
                          style={{
                            color: total ? "#f0c060" : "#ccc",
                            fontWeight: total ? "bold" : "normal",
                          }}
                        >
                          {koot}
                        </td>
                        <td
                          className="td-val"
                          style={{
                            fontWeight: "bold",
                            fontSize: "1.05rem",
                            color: total ? "#f0c060" : "#6dff9e",
                          }}
                        >
                          {max}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* गुण मिलान महत्त्व */}
              <div style={{ flex: "2 1 320px" }}>
                <h3
                  style={{
                    color: "#f0c060",
                    marginBottom: "0.6rem",
                    fontSize: "1rem",
                    letterSpacing: "0.03em",
                  }}
                >
                  गुण मिलानको महत्त्व
                </h3>
                <table className="milan-table garuda-table">
                  <thead>
                    <tr>
                      <th className="th-naksha" style={{ color: "#7ecfff" }}>
                        प्राप्त गुण
                      </th>
                      <th className="th-naksha" style={{ color: "#7ecfff" }}>
                        फलादेश
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      {
                        range: "१८ भन्दा कम",
                        result: "विवाहको लागि उचित मानिँदैन",
                        color: "#ff5c5c",
                      },
                      {
                        range: "१८ देखि २४",
                        result: "सामान्य, स्वीकार्य मिलान — विवाहको लागि उचित",
                        color: "#ffe066",
                      },
                      {
                        range: "२४ देखि ३२",
                        result: "उत्तम, सफल विवाह",
                        color: "#6dff9e",
                      },
                      {
                        range: "३२ देखि ३६",
                        result: "उत्कृष्ट मिलान",
                        color: "#7ecfff",
                      },
                    ].map(({ range, result, color }, i) => (
                      <tr
                        key={i}
                        className={i % 2 === 0 ? "row-accent" : "row-highlight"}
                      >
                        <td
                          className="td-val"
                          style={{
                            fontWeight: "bold",
                            color,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {range}
                        </td>
                        <td className="td-val" style={{ color: "#ddd" }}>
                          {result}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}

        {/* ══ GARUDA TABLE ══ */}
        {activeTab === "garuda" && (
          <div className="milan-scroll">
            <p className="garuda-note">
              नामाक्षर अनुसार वर्ग र शत्रुवर्ग निर्धारण
            </p>
            <table className="milan-table garuda-table">
              <thead>
                <tr>
                  <th className="th-label">नामाक्षर</th>
                  {GARUDA_HEADERS.map((h, i) => (
                    <th key={i} className="th-naksha">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Object.entries(GARUDA_ROWS).map(([rowName, vals], ri) => (
                  <tr
                    key={ri}
                    className={ri === 0 ? "row-highlight" : "row-accent"}
                  >
                    <td className="td-label">{rowName}</td>
                    {vals.map((v, ci) => (
                      <td key={ci} className="td-val">
                        {v}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* ══ NOTES ══ */}
        {activeTab === "notes" && (
          <div className="notes-panel">
            <div className="note-card">
              <h3 className="note-title">भीमदोषज्ञानम्</h3>
              <p className="note-text">
                लग्ने १ व्यये १२ च पाताले ४ जामित्रे ७ चाष्टमे कुजे। पत्नी हन्ति
                स्वभर्तारं भर्ता भार्गं न संशयः।
              </p>
            </div>
            <div className="note-card">
              <h3 className="note-title">भीमदोषपरिहार</h3>
              <p className="note-text">
                जामित्रे च यदा सौरिलग्ने वा हिबुके थ वा। नवमे द्वादशे चैव
                भीमदोपो न विद्यते।
              </p>
            </div>
            <div className="note-card">
              <h3 className="note-title">नोट</h3>
              <p className="note-text">
                जु जे जो ख अभिजित् (उत्तराषाढाको चौथो पाउ र श्रवणको १५ भागको १
                भाग मिलेर बनेको हुन्छ)।
              </p>
            </div>
            <div className="note-card">
              <h3 className="note-title">मङ्गली</h3>
              <p className="note-text">
                न मङ्गली चन्द्रभृगु द्वितीये न मङ्गलो पश्यति यस्य जीवः। न मङ्गली
                केन्द्रगते च राहुनमङ्गली मङ्गलराहुयोगे।
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
